import styled from 'styled-components'

import { Label } from '@nx/fire/typography'
import { SmartlingAttributes } from '@nx/smartling'
import { getTranslate } from '@nx/translations'

import {
  StyledGreyOverlay,
  StyledPlayedIcon,
  ThumbImage,
} from './Carousel.styles'
import translate from './Carousel.translate.json'

const { text } = getTranslate(translate)

export const JumpToVideo = ({
  src,
  alt,
  onClick,
}: {
  src: string
  alt: string
  onClick: () => void
}) => (
  <Container onClick={onClick}>
    <ImageContainer>
      <StyledThumbImage
        src={`https://content.jwplatform.com/thumbs/${src}-320.jpg`}
        alt={text('thumbnailOf', { alt })}
        {...SmartlingAttributes.noTranslate}
      />

      <StyledGreyOverlay>
        <StyledPlayedIcon />
      </StyledGreyOverlay>
    </ImageContainer>
    <Label $level="S" as="span">
      {text('watch')}
    </Label>
  </Container>
)

const Container = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colours.grey[15]};
  border: none;
  display: flex;
  gap: 13px;
  height: 56px;
  margin-top: 10px;
  width: 100%;

  ${({ theme }) => theme.media.up.md} {
    display: none;
  }
`

const ImageContainer = styled.div`
  height: 56px;
  position: relative;
`

const StyledThumbImage = styled(ThumbImage)`
  height: 100%;
`
